import React from "react";
import { Instagram, Linkedin, MessageSquare, Mail, Phone, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT, CONTACTS } from "../../data/hseData";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-black border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-16">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <Logo size="lg" />
            <p className="mt-6 font-body text-sm text-white/55 leading-relaxed max-w-md">
              Desde 2006, a HSE Soluções e Serviços entrega soluções técnicas em segurança, meio ambiente, treinamentos, serviços industriais críticos e resposta a emergências.
            </p>
            <div className="mt-6 inline-flex items-center gap-3 border border-[#2FA36B]/50 px-3 py-2">
              <span className="w-2 h-2 bg-[#2FA36B] block animate-pulse" />
              <span className="font-condensed uppercase text-[10px] tracking-[0.3em] text-white/80 font-bold">
                20 anos · 2006 — 2026
              </span>
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="font-condensed uppercase text-[10px] tracking-[0.3em] text-[#2FA36B] font-bold mb-5">Navegação</p>
            <ul className="space-y-3 font-body text-sm">
              {[
                ["#sobre", "Sobre"],
                ["#anos", "20 Anos"],
                ["#servicos", "Serviços"],
                ["#diferenciais", "Diferenciais"],
                ["#cases", "Cases"],
                ["#segmentos", "Segmentos"],
                ["#contato", "Contato"],
                ["/politica-de-privacidade", "Privacidade (LGPD)"],
              ].map(([h, l]) => (
                <li key={h}>
                  <a data-testid={`footer-nav-${h.replace("#", "")}`} href={h} className="text-white/65 hover:text-white transition-colors">
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="font-condensed uppercase text-[10px] tracking-[0.3em] text-[#2FA36B] font-bold mb-5">Contato</p>
            <ul className="space-y-4 font-body text-sm">
              {CONTACTS.map((c) => (
                <li key={c.email} className="border-l-2 border-[#2FA36B] pl-3">
                  <p className="font-condensed uppercase text-[10px] tracking-[0.2em] text-[#2FA36B] font-bold">{c.role}</p>
                  <p className="text-white font-semibold">{c.name}</p>
                  <p className="flex items-center gap-2 text-white/70"><MessageSquare size={12} /> {c.phone}</p>
                  <p className="flex items-center gap-2 text-white/70"><Mail size={12} /> {c.email}</p>
                </li>
              ))}
              <li className="flex items-center gap-3 text-white/70 pt-1">
                <MapPin size={14} className="text-[#2FA36B]" /> {CONTACT.address}
              </li>
              <li>
                <Phone size={14} className="inline text-[#2FA36B] mr-2" />
                <a href="/admin" data-testid="footer-admin-link" className="text-white/50 hover:text-[#2FA36B] text-xs">Área restrita · Admin</a>
              </li>
            </ul>

            <div className="mt-6 flex gap-3">
              <a data-testid="footer-instagram" href={CONTACT.instagram} target="_blank" rel="noreferrer" className="w-10 h-10 border border-white/15 hover:border-[#2FA36B] hover:bg-[#2FA36B] flex items-center justify-center transition-all">
                <Instagram size={16} className="text-white" />
              </a>
              <a data-testid="footer-linkedin" href={CONTACT.linkedin} target="_blank" rel="noreferrer" className="w-10 h-10 border border-white/15 hover:border-[#2FA36B] hover:bg-[#2FA36B] flex items-center justify-center transition-all">
                <Linkedin size={16} className="text-white" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-body text-xs text-white/40">
            © {new Date().getFullYear()} HSE Soluções e Serviços. Todos os direitos reservados.
          </p>
          <p className="font-condensed uppercase text-[10px] tracking-[0.3em] text-white/30 font-bold">
            Segurança · Meio Ambiente · Serviços Críticos · Emergência
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
